<template>
    <div class="box">
        <div class="header">
            <div class="tc f16 txt_black bold600">我的收益</div>
        </div>
        <div class="data">
            <div class="f13 txt_461E04">可提现收益（元）</div>
            <div class="f36 txt_black bold600" v-text="fund.withdrawAmount"></div>
            <div class="earnings">
                <div>
                    <div class="txt_666666 f12">本月收益(元)</div>
                    <div class="f20 txt_black bold600" v-text="fund.all"></div>
                </div>
                <div>
                    <div class="txt_666666 f12">本月实际收益(元)</div>
                    <div class="f20 txt_black bold600" v-text="fund.allReal"></div>
                </div>
                <div>
                    <div class="txt_666666 f12">今日收益(元)</div>
                    <div class="f20 txt_black bold600" v-text="fund.todayAmount"></div>
                </div>
            </div>
        </div>

        <div class="submit" @click="withdrawalEvent">申请提现</div>
    </div>
</template>

<script>
    export default {
        name: "withdrawal",
        data() {
            return {
                fund: {
                    all: '',
                    allReal: '',
                    todayAmount: '',
                    todayReal: '',
                    withdrawAmount: ''
                }
            }
        },
        created() {
            this.getFund();
        },
        methods: {
            getFund() {
                this.$api.get('/manage/survey/fund').then((data) => {
                    this.fund = data;
                }).catch((error) => {
                    this.$alert.error({content: '获取账户资金信息出错'});
                });
            },
            withdrawalEvent() {
                if(this.fund.withdrawAmount > 0) {
                    this.$router.push({
                        path: '/partnerWithdrawalAmount',
                        name: 'mobilePartnerWithdrawalAmount',
                        params: {amount: this.fund.withdrawAmount}
                    });
                }else {
                    this.$modal({content: '可提现金额大于0才能提现'});
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        flex: 1;
        background-color: #F8F8F8;
    }
    .header {
        width: 100%;
        height: 257px;
        background-image: linear-gradient(136deg, #FFF4DB 0%, #FFEBBF 100%);
        padding-top: 10px;
    }
    .data {
        width: 90%;
        height: 215px;
        margin: -150px 5% 0 5%;
        background-color: #FFEBBF;
        border-radius: 12px;
        padding: 20px 6% 0 6%;
    }
    .earnings {
        width: 106%;
        height: 80px;
        background-color: white;
        margin-left: -3%;
        margin-top: 15px;
        border-radius: 10px;
        display: flex;
    }
    .earnings > div {
        flex: 1;
        height: 50px;
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: #EEEEEE 1px solid;
    }
    .earnings > div:nth-last-of-type(1) {
        border-right: none;
    }
    .submit {
        width: 90%;
        height: 44px;
        background: #FF6B11;
        border-radius: 22px;
        margin-left: 5%;
        color: white;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        position: fixed;
        left: 0;
        bottom: 50px;
    }
</style>